import { useApi } from '@backstage/core-plugin-api';
import { useEffect, useState } from 'react';
import { permitBuildApiRef } from '../../../../apis/permitToBuildApi';
import {
  NotificationApi,
  notificationApiRef,
} from '../../../../apis/notificationApi';

export const useTickets = (shouldcall: boolean) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);
  const permitBuildApi = useApi(permitBuildApiRef);

  // const [tickets, setTickets] = useState<any[]>([]);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);

  const addConfig = async (ticket: any) => {
    setSaveLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.saveTicket(ticket);
        if (response?.data || response?.message) {
          setSaveLoading(false);
          // setTickets((prevState: any) => [...prevState, response.data]);
          notificationApi.sendNotification({
            message: response?.message, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setSaveLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const saveNewAssetRequest = async (newAsset: any) => {
    setSaveLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.saveNewAssetRequest(newAsset);
        if (response?.data || response?.message) {
          setSaveLoading(false);
          // setTickets((prevState: any) => [...prevState, response.data]);
          notificationApi.sendNotification({
            message: response?.message, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setSaveLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const sendReminder = async (id: any) => {
    setSaveLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.sendReminder(id);
        if (response?.data || response?.message) {
          setSaveLoading(false);
          notificationApi.sendNotification({
            message: response?.message, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setSaveLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const deleteTicket = async (id: any) => {
    setSaveLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.deleteTicket(id);
        if (response?.data || response?.message) {
          setSaveLoading(false);
          notificationApi.sendNotification({
            message: response?.message, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setSaveLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const saveComment = async (comment: any) => {
    setSaveLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.saveComment(comment);
        if (response?.data || response?.message) {
          setSaveLoading(false);
          // setTickets((prevState: any) => [...prevState, response.data]);
          notificationApi.sendNotification({
            message: response?.message, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setSaveLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  const batchSaveAssets = async (ticketNumber: any, assets: any) => {
    setSaveLoading(true);
    if (permitBuildApi) {
      try {
        const response = await permitBuildApi.batchSaveAssets(
          ticketNumber,
          assets,
        );
        if (response?.data || response?.message) {
          setSaveLoading(false);
          // setTickets((prevState: any) => [...prevState, response.data]);
          notificationApi.sendNotification({
            message: response?.message, // response?.reason || 'Success',
            disapperAfterMs: 2500,
            severity: 'success',
          });
        }
      } catch (error) {
        setSaveLoading(false);
        notificationApi.sendNotification({
          message: `Error occurred - ${error}`,
          disapperAfterMs: 2500,
          severity: 'error',
        });
      }
    }
    return null;
  };

  return {
    // tickets,
    addConfig,
    saveComment,
    saveNewAssetRequest,
    batchSaveAssets,
    sendReminder,
    deleteTicket,
    saveLoading,
  } as const;
};
